const utils = require('./utils');
const allowAmount = process.env.REACT_APP_CHEST_ALLOWANCE;

export const approve = async (contractAddress, amount, selectedAccount, setConfirm, web3, setApproveFlag, approveFlag, setSubmitProcessing) => {
  const maticPOSClient = utils.getMaticPOSClient(selectedAccount, web3);

  try {
    setSubmitProcessing(true);
    let chestConfig = contractAddress;
    let tx;
    let fixedAmount = web3.utils.toWei(allowAmount.toString(), 'ether')
    let allowance = await maticPOSClient.getERC20Allowance(
      selectedAccount,
      chestConfig
    )

    let gasPrice = await web3.eth.getGasPrice();        
    let gasPriceBN = web3.utils.toBN(gasPrice);
    let finalGasPrice = gasPriceBN.add(web3.utils.toBN(parseInt(0.1 * gasPriceBN))).toString();

    if(!approveFlag && allowance == 0) {
      tx = await maticPOSClient.approveERC20ForDeposit(
        chestConfig,
        fixedAmount,
        {
          from: selectedAccount,
          gasPrice: finalGasPrice
        },
      ).then(() => {
        setConfirm('approve');
      });
      setApproveFlag(true);
    }

    if(parseInt(allowance) <= parseInt(amount)) {
     tx = await maticPOSClient.approveERC20ForDeposit(
        chestConfig,
        amount,
        {
          from: selectedAccount,
          gasPrice: finalGasPrice
        },
      ).then(() => {
        setConfirm('approve');
      });
      setApproveFlag(false);
    } 

    // console.log("Txn hash: ", tx.transactionHash); // eslint-disable-line
  } catch (e) {
    console.error(e); // eslint-disable-line
    setConfirm('');
    throw new Error(e);
  }
};

// execute().then(() => process.exit(0))
